import { useCallback, useRef, useState } from 'react';
export function useTTS() {
  const [isReady, setIsReady] = useState(true);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const speak = useCallback(async (text: string) => {
    // Zatrzymujemy poprzednie odtwarzanie, jeśli istnieje
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }

    // TODO: Zmień na zmienną środowiskową przed produkcją
    const apiKey = 'AIzaSyAQUvGuZyMwP4eIo7EXvmvv_xTMd5zX4y8';
    if (!apiKey || apiKey === 'AIzaSyAQUvGuZyMwP4eIo7EXvmvv_xTMd5zX4y8') {
      console.warn('Brak klucza API Google TTS. Upewnij się, że VITE_GOOGLE_TTS_API_KEY jest ustawione w pliku .env');

      // Fallback do Web Speech API jeśli brak klucza
      if (window.speechSynthesis) {
        window.speechSynthesis.cancel();
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = 'pl-PL';
        utterance.rate = 0.85;
        const voices = window.speechSynthesis.getVoices();
        const polishVoice = voices.find(v => v.lang.startsWith('pl') && (v.name.includes('Zosia') || v.name.includes('Paulina') || v.name.includes('Google')));
        if (polishVoice) utterance.voice = polishVoice;
        window.speechSynthesis.speak(utterance);
      }
      return;
    }
    try {
      const response = await fetch(`https://texttospeech.googleapis.com/v1/text:synthesize?key=${apiKey}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          input: {
            text: text
          },
          voice: {
            languageCode: 'pl-PL',
            name: 'pl-PL-Wavenet-A' // Kobiecy, spokojny głos Wavenet
          },
          audioConfig: {
            audioEncoding: 'MP3',
            speakingRate: 0.85,
            // Wolniejsze tempo dla efektu wellness/calm
            pitch: -2.0 // Lekko obniżony ton dla większego spokoju
          }
        })
      });
      if (!response.ok) {
        throw new Error(`Google TTS API error: ${response.status}`);
      }
      const data = await response.json();
      const audioContent = data.audioContent;

      // Tworzymy nowy element Audio z otrzymanego base64
      const audio = new Audio(`data:audio/mp3;base64,${audioContent}`);
      audioRef.current = audio;
      await audio.play();
    } catch (error) {
      console.error('Błąd podczas generowania mowy:', error);

      // Fallback do Web Speech API w razie błędu
      if (window.speechSynthesis) {
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = 'pl-PL';
        utterance.rate = 0.85;
        window.speechSynthesis.speak(utterance);
      }
    }
  }, []);
  const stop = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    if (window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }
  }, []);
  return {
    speak,
    stop,
    isReady
  };
}